export const FILE_SIZE_BASE = 1000;
export const MAX_FILE_SIZE_UPLOAD = 5 * FILE_SIZE_BASE * FILE_SIZE_BASE * FILE_SIZE_BASE; // 5GB
export const MAX_FILE_SIZE_UPLOAD_SERVICENOW_TICKET_ATTACHMENT = 4.5 * FILE_SIZE_BASE * FILE_SIZE_BASE; // 4.5MB
export const TABLE_DEFAULT_PAGE_SIZE = 10;
export const TABLE_DEFAULT_PAGE_INDEX = 0;

export const COMMON_ADDITIONAL_VALUE = 5;
export const COMMON_MAX_CHARACTERS_INPUT = 255;
export const COMMON_MAX_CHARACTERS_TEXTAREA = 1024;
export const SERVICE_NOW_REPLY_BY_DIGITALHANDS_NAME = 'Digital Hands';

export const MAX_FILTER_NAME_INPUT_LENGTH = 50;
export const FILTER_NAME_REGEX = /^[a-zA-Z0-9\s]+$/;
export const MAX_SERVICE_NOW_TICKET_RESOLUTION_NOTE_CHARACTERS = {
  DESKTOP: 128,
  TABLET: 32,
  MOBILE: 32,
};

export const DEFAULT_PERIOD_SELECTOR_VALUE = 180;

export const CURRENT_SAVED_FILTER_ID = 'current-select-saved-filter-id';
// Pagination
export const DEFAULT_PAGE_SIZE = 5;
export const DEFAULT_PAGE = 1;
